// src/components/homePage/UsersMetricsCharts.jsx
import { useSelector } from "react-redux";
import { Box, Chip, Grid } from "@mui/material";

// import CustomCard from "../../CustomCard";
import UserGroupFilter from "../../Filters/UserGroupFilter/UserGroupFilter";
import TimePeriodFilter from "../../Filters/TimePeriodFilter/TimePeriodFilter";
import BUFilter from "../../Filters/BUFilter/BUFilter";

import TotalUsersChart from "../../../features/dashboard/components/charts/TotalUsersChart/TotalUsersChart";
import UserInteractionChart from "../../../features/dashboard/components/charts/UserInteractionChart/UserInteractionChart";
import WeeklyUsersChart from "../../../features/dashboard/components/charts/WeeklyUsersChart/WeeklyUsersChart";
import QuestionTypeChart from "../../../features/dashboard/components/charts/QuestionTypeChart/QuestionTypeChart";
import FeedbackCountTable from "../../../features/dashboard/components/charts/FeedbackCountTable/FeedbackCountTable";
import FeedbackTypeChart from "../../../features/dashboard/components/charts/FeedbackTypeChart/FeedbackTypeChart";
import CustomCard from "../../CustomCard";
import ResetFiltersButton from "../../Filters/ResetFilters/ResetFilters";

const UsersMetricsCharts = () => {
  const { businessUnit } = useSelector((s) => s.filters);
  const { cardData, cardDataFetching } = useSelector((s) => s.dashboard);

  return (
    <Box height="92vh" overflow="auto" sx={{ scrollbarWidth: "none" }}>
      {/* ── Filter Bar ── */}
      <Grid container p={3} alignItems="center" justifyContent="space-between">
        <Grid item xs="auto">
          <TimePeriodFilter />
        </Grid>
        <Grid
          item
          xs
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          gap={5}
        >
          <UserGroupFilter />
          <Grid display="flex" alignItems="center" gap={1.5}>
            <Chip
              label={businessUnit}
              variant="outlined"
              sx={{
                fontSize: "13px",
                height: "32px",
                borderRadius: "8px",
                borderColor: "#fff",
                background: "#333",
                color: "#fff",
              }}
            />
            <BUFilter />
          </Grid>
          <ResetFiltersButton />
        </Grid>
      </Grid>

      <Grid container p={3} spacing={2}>
        <Grid size={{ xs: 12, md: 2.5 }}>
          <CustomCard data={cardData} loading={cardDataFetching} />
        </Grid>

        <Grid size={{ xs: 12, md: 9.5 }}>
          <TotalUsersChart />
        </Grid>
      </Grid>

      <Grid container spacing={2} p={3}>
        <Grid size={{ xs: 12 }}>
          <UserInteractionChart />
        </Grid>
      </Grid>

      <Grid container spacing={2} p={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <WeeklyUsersChart />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <QuestionTypeChart />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <FeedbackCountTable />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <FeedbackTypeChart />
        </Grid>
      </Grid>
    </Box>
  );
};

export default UsersMetricsCharts;
